import React, { useMemo } from 'react'
import Button from '@material-ui/core/Button'
import VisibilityIcon from '@material-ui/icons/Visibility'
import { useSelector } from 'react-redux'
import processQuestionnaire from '../../../utils/ProcessQuestionnaire'

export const PreviewQuestionnaireButton = () => {
  const questions = useSelector((state) => state.questions)

  const encodeBase64 = (str) => {
    const utf8Bytes = new TextEncoder().encode(str)
    return btoa(String.fromCharCode(...utf8Bytes))
  }

  const questionnaireDefinition = useMemo(
    () => encodeBase64(JSON.stringify(processQuestionnaire(questions))),
    [questions]
  )

  return (
    <div>
      <form
        id='previewForm'
        method='POST'
        action={`${window.env.SVC_QUESTIONNAIRES_BASE_URL}/questionnaire/interactive_post`}
        target='_blank'
      >
        <input
          type='hidden'
          name='content'
          id='contentInput'
          value={questionnaireDefinition}
        />
        <Button type='submit' color='inherit' startIcon={<VisibilityIcon />}>
          Preview
        </Button>
      </form>
    </div>
  )
}
